var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "details-view" },
        [
          _c(
            "cargo-left-right-resize",
            {
              ref: "cargoLeftRightResize",
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": { flex: "none" },
                "right-style": { overflow: "hidden" },
                "show-left": _vm.action === "look" || _vm.showBasicInfoForCharge
              }
            },
            [
              _c(
                "template",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.action === "look",
                      expression: "action==='look'"
                    }
                  ],
                  slot: "left"
                },
                [
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.action === "look",
                        expression: "action==='look'"
                      }
                    ],
                    staticStyle: {
                      "min-width": "160px",
                      width: "100%",
                      height: "100%"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  }),
                  _vm.showBasicInfoForCharge
                    ? _c("cargo-ag-grid", {
                        staticClass: "section",
                        attrs: {
                          "grid-options": _vm.basicInfo.gridOptions,
                          "row-data": _vm.basicInfo.rowData,
                          "show-side-bar": false,
                          "check-sub-record": false,
                          "check-main-record": false,
                          "deselect-main-record": false,
                          "deselect-sub-record": false,
                          "min-height": "100%",
                          "grid-style":
                            "min-width: 160px;width:100%;height:100%;"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("template", { slot: "right" }, [
                _c("div", { staticClass: "main-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "operations",
                      staticStyle: { "margin-bottom": "5px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "triggers" },
                        [
                          _c(
                            "cargo-button-group-slider",
                            { ref: "cargoButtonGroupSlider" },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.action === "look",
                                      expression: "action==='look'"
                                    }
                                  ],
                                  class:
                                    "btn-group-look" +
                                    (_vm.canOperateJob
                                      ? ""
                                      : " cannot-operate-job")
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "can-operate",
                                      attrs: { no: "1", type: "primary" },
                                      on: { click: _vm.goBack }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "2",
                                        disabled: !(
                                          _vm.job &&
                                          Number(_vm.job.jobState) === 0 &&
                                          !_vm.JobUtils.isBlockJob(_vm.job)
                                        ),
                                        type: "success"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.editEventFlag = true
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.$checkPermission([
                                            "button_AEBooking_addAEBooking"
                                          ]),
                                          expression:
                                            "$checkPermission(['button_AEBooking_addAEBooking'])"
                                        }
                                      ],
                                      attrs: { no: "3", type: "primary" },
                                      on: { click: _vm.toCopy }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.$checkPermission([
                                              "button_AEBooking_addAEBooking"
                                            ]) && _vm.showImportOrder,
                                          expression:
                                            "$checkPermission(['button_AEBooking_addAEBooking']) && showImportOrder"
                                        }
                                      ],
                                      attrs: {
                                        no: "copyFromJob",
                                        type: "primary"
                                      },
                                      on: { click: _vm.importOrder }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.ImportOrder"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "4", type: "success" },
                                      on: { click: _vm.onPrint }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.btnInfo.visible.profitPrintable,
                                          expression:
                                            "btnInfo.visible.profitPrintable"
                                        }
                                      ],
                                      attrs: { no: "5", type: "primary" },
                                      on: { click: _vm.profitPrintHandler }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.PrintProfitAnalysis"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.btnInfo.visible.btnPreSubmit,
                                          expression:
                                            "btnInfo.visible.btnPreSubmit"
                                        }
                                      ],
                                      attrs: {
                                        no: "6",
                                        type: "primary",
                                        disabled: _vm.isCooperate
                                      },
                                      on: { click: _vm.doSubmitPrint_PreSubmit }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.PreSubmission")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.btnInfo.visible.btnSubmit,
                                          expression:
                                            "btnInfo.visible.btnSubmit"
                                        }
                                      ],
                                      attrs: {
                                        no: "7",
                                        type: "primary",
                                        disabled: _vm.isCooperate
                                      },
                                      on: { click: _vm.doSubmitPrint_Submit }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Submission"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.btnInfo.visible
                                              .btnManagerSubmit,
                                          expression:
                                            "btnInfo.visible.btnManagerSubmit"
                                        }
                                      ],
                                      staticClass: "can-operate",
                                      attrs: {
                                        no: "8",
                                        type: "primary",
                                        disabled: _vm.isCooperate
                                      },
                                      on: {
                                        click: _vm.doSubmitPrint_ManagerSubmit
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.ManagerSubmission")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.btnInfo.visible
                                              .btnManagerAuditSubmit,
                                          expression:
                                            "btnInfo.visible.btnManagerAuditSubmit"
                                        }
                                      ],
                                      attrs: {
                                        no: "9",
                                        type: "primary",
                                        disabled: _vm.isCooperate
                                      },
                                      on: {
                                        click: _vm.doSubmitAudit_ManagerSubmit
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Audit")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.btnInfo.visible
                                              .printReturnOperate,
                                          expression:
                                            "btnInfo.visible.printReturnOperate"
                                        }
                                      ],
                                      attrs: {
                                        no: "10",
                                        type: "primary",
                                        disabled: _vm.isCooperate
                                      },
                                      on: { click: _vm.backReturn }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.ReturnAction"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.btnInfo.visible.cancelable,
                                          expression:
                                            "btnInfo.visible.cancelable"
                                        }
                                      ],
                                      staticClass: "can-operate",
                                      attrs: {
                                        no: "11",
                                        type: "primary",
                                        disabled:
                                          _vm.isCooperate ||
                                          _vm.controlledLocked
                                      },
                                      on: { click: _vm.backReturn }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.PrintReturn"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.$checkPermission([
                                              "button_JobBooking_ReturnReview"
                                            ]) && _vm.showReturnReview,
                                          expression:
                                            "$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                                        }
                                      ],
                                      attrs: {
                                        no: "returnReview",
                                        type: "primary"
                                      },
                                      on: { click: _vm.returnReview }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_ReturnPreApprovalRemoteBooking"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  (_vm.job.shutOut
                                  ? _vm.btnInfo.privilege
                                      .button_AEBooking_cancelShutout
                                  : _vm.btnInfo.privilege
                                      .button_AEBooking_Shutout)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "12",
                                            type: "primary",
                                            disabled:
                                              !(
                                                _vm.job.jobState ===
                                                  _vm.SystemConstants
                                                    .OPERATING ||
                                                _vm.job.jobState ===
                                                  _vm.SystemConstants.SHUT_OUT
                                              ) || _vm.isCooperate
                                          },
                                          on: { click: _vm.toShutOut }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.btnInfo.label.shutOutLabel
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.showCooperateButton &&
                                            !_vm.isRegionalCommission,
                                          expression:
                                            "showCooperateButton&&!isRegionalCommission"
                                        }
                                      ],
                                      attrs: {
                                        no: "bntCooperation",
                                        type: "primary"
                                      },
                                      on: { click: _vm.cooperationHandler }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_Cooperation")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showReturnButton,
                                          expression: "showReturnButton"
                                        }
                                      ],
                                      attrs: {
                                        no: "bntCooperationReturn",
                                        type: "primary"
                                      },
                                      on: {
                                        click: _vm.cooperationReturnHandler
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_CooperationReturn"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showSendCompany,
                                          expression: "showSendCompany"
                                        }
                                      ],
                                      class:
                                        _vm.btnInfo.label
                                          .SendToBranchCompany ===
                                        _vm.$t(
                                          "SeaExport.AssociationBusinessInformation"
                                        )
                                          ? "can-operate"
                                          : "",
                                      attrs: {
                                        no: "13",
                                        type: "primary",
                                        disabled:
                                          !_vm.btnInfo.privilege.sendable &&
                                          !_vm.btnInfo.visible.btSendBranch
                                      },
                                      on: { click: _vm.sendBranchHandlerPre }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.btnInfo.label.SendToBranchCompany
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.VERIFIED &&
                                            _vm.job.changeState ===
                                              _vm.SystemConstants.VERIFIED &&
                                            _vm.$checkPermission([
                                              "button_JobBooking_ChangeCommit"
                                            ]) &&
                                            Number(
                                              _vm.config.get(
                                                "IsCommittedAllowAddCost"
                                              )
                                            ) === 1,
                                          expression:
                                            "job.jobState === SystemConstants.VERIFIED && job.changeState === SystemConstants.VERIFIED && $checkPermission(['button_JobBooking_ChangeCommit']) && Number(config.get('IsCommittedAllowAddCost')) === 1"
                                        }
                                      ],
                                      attrs: { no: "14", type: "primary" },
                                      on: {
                                        click: _vm.changeCommit_clickHandler
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.ChangeCommit"))
                                      )
                                    ]
                                  ),
                                  _vm.showAEToAI
                                    ? [
                                        _vm.btnInfo.label.btnEntrustmentAI ===
                                          _vm.$t(
                                            "SeaExport.AssociationBusinessInformationSI"
                                          ) &&
                                        _vm.job.relatedJob &&
                                        !_vm.isRegionalCommission
                                          ? _c(
                                              "el-dropdown",
                                              {
                                                staticClass:
                                                  "el-dropdown-spacing can-operate",
                                                attrs: {
                                                  no:
                                                    "AssociationBusinessInformationSI",
                                                  "split-button": "",
                                                  type: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.syncInfoHandle()
                                                  },
                                                  command: function(p) {
                                                    _vm.syncInfoCommand = p
                                                    _vm.syncInfoHandle()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.syncInfoCommand) +
                                                    " "
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown"
                                                  },
                                                  [
                                                    _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: _vm.$t(
                                                            "SeaExport.AssociationBusinessInformationSI"
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SeaExport.AssociationBusinessInformationSI"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-item",
                                                      {
                                                        class: _vm.canOperateJob
                                                          ? ""
                                                          : "ae-detail-cannot-operate-job",
                                                        attrs: {
                                                          command: _vm.$t(
                                                            "SeaExport.SynchronizationInformation"
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SeaExport.SynchronizationInformation"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm.job.masterFlag ||
                                            !(
                                              _vm.job.operateType ===
                                              _vm.AirExportConstants.CONSOLE
                                                .code
                                            )
                                          ? _c(
                                              "el-button",
                                              {
                                                class:
                                                  _vm.btnInfo.label
                                                    .btnEntrustmentAI ===
                                                  _vm.$t(
                                                    "SeaExport.AssociationBusinessInformationSI"
                                                  )
                                                    ? "can-operate"
                                                    : "",
                                                attrs: {
                                                  no: "15",
                                                  type: "primary",
                                                  disabled: !(
                                                    _vm.btnInfo.privilege
                                                      .consignationEnableAI &&
                                                    _vm.$store.getters
                                                      .isGroupCompany
                                                  )
                                                },
                                                on: {
                                                  click:
                                                    _vm.entrustmentSIClickHandler
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.btnInfo.label
                                                      .btnEntrustmentAI
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.crossDelegationSynchronizationField &&
                                            (_vm.job.relatedJob ||
                                              _vm.job.trustFromJob),
                                          expression:
                                            "crossDelegationSynchronizationField && (job.relatedJob || job.trustFromJob)"
                                        }
                                      ],
                                      attrs: {
                                        no: "16",
                                        disabled:
                                          _vm.job.jobState !==
                                          _vm.SystemConstants.STATE_OPERATING
                                            .code,
                                        type: "primary"
                                      },
                                      on: { click: _vm.syncRelatedJob }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.SynchronizationInformation"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown",
                                    {
                                      staticClass:
                                        "el-dropdown-spacing can-operate",
                                      attrs: {
                                        no: "16",
                                        "split-button": "",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.logHandle()
                                        },
                                        command: function(p) {
                                          _vm.logCommand = p
                                          _vm.logHandle()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_LogRecord")
                                        )
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "CargoMsg.Cargo_BusinessStatusChangeLog"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_BusinessStatusChangeLog"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.DataPushChangeLog"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.DataPushChangeLog"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.OperationLog"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.OperationLog"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.OPERATING &&
                                            !_vm.masterFlag &&
                                            _vm.action === "look" &&
                                            !_vm.job.purchasePriceLock &&
                                            _vm.$checkPermission([
                                              "button_AEBooking_PurchasePriceLock"
                                            ]),
                                          expression:
                                            "job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && !job.purchasePriceLock && $checkPermission(['button_AEBooking_PurchasePriceLock'])"
                                        }
                                      ],
                                      attrs: {
                                        no: "PurchasePriceLock",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updatePriceLock_clickHandler(
                                            true,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_lockLabel1")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.OPERATING &&
                                            !_vm.masterFlag &&
                                            _vm.action === "look" &&
                                            !_vm.job.sellingPriceLock &&
                                            _vm.$checkPermission([
                                              "button_AEBooking_SellingPriceLock"
                                            ]),
                                          expression:
                                            "job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && !job.sellingPriceLock && $checkPermission(['button_AEBooking_SellingPriceLock'])"
                                        }
                                      ],
                                      attrs: {
                                        no: "SellingPriceLock",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updatePriceLock_clickHandler(
                                            false,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_lockLabel2")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.OPERATING &&
                                            !_vm.masterFlag &&
                                            _vm.action === "look" &&
                                            _vm.job.purchasePriceLock &&
                                            _vm.$checkPermission([
                                              "button_AEBooking_PurchasePriceUnLock"
                                            ]),
                                          expression:
                                            "job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && job.purchasePriceLock && $checkPermission(['button_AEBooking_PurchasePriceUnLock'])"
                                        }
                                      ],
                                      attrs: {
                                        no: "PurchasePriceUnLock",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updatePriceLock_clickHandler(
                                            true,
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_lockLabel3")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.OPERATING &&
                                            !_vm.masterFlag &&
                                            _vm.action === "look" &&
                                            _vm.job.sellingPriceLock &&
                                            _vm.$checkPermission([
                                              "button_AEBooking_SellingPriceUnLock"
                                            ]),
                                          expression:
                                            "job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && job.sellingPriceLock && $checkPermission(['button_AEBooking_SellingPriceUnLock'])"
                                        }
                                      ],
                                      attrs: {
                                        no: "SellingPriceUnLock",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updatePriceLock_clickHandler(
                                            false,
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_lockLabel4")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.action === "edit",
                                      expression: "action==='edit'"
                                    }
                                  ],
                                  staticClass: "btn-group-edit",
                                  staticStyle: {
                                    "border-left": "none",
                                    "padding-left": "0"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "17",
                                        type: "success",
                                        disabled: _vm.context.loading
                                      },
                                      on: { click: _vm.save }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "18", type: "success" },
                                      on: {
                                        click: function($event) {
                                          _vm.cancelEdit(function() {
                                            _vm.againShow("look")
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.btn.cancel"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "19", type: "primary" },
                                      on: { click: _vm.saveDefaultVal }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.SaveTheDefaultValues"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isNew,
                                      expression: "isNew"
                                    }
                                  ],
                                  staticClass: "btn-group-new",
                                  staticStyle: {
                                    "border-left": "none",
                                    "padding-left": "0"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "20",
                                        type: "success",
                                        disabled: _vm.context.loading
                                      },
                                      on: { click: _vm.save }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "21", type: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelEdit(_vm.goBack)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.btn.cancel"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "22", type: "primary" },
                                      on: { click: _vm.saveDefaultVal }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.SaveTheDefaultValues"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.action === "look" ||
                                    _vm.action === "edit",
                                  expression:
                                    "action==='look'|| action==='edit'"
                                }
                              ],
                              staticStyle: {
                                "padding-left": "6px",
                                "border-left": "2px solid #FFF",
                                "margin-left": "10px",
                                display: "flex",
                                "white-space": "nowrap"
                              }
                            },
                            [
                              _c("CargoIm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.imCacheKey && _vm.action === "look",
                                    expression: "imCacheKey && action==='look'"
                                  }
                                ],
                                ref: "cargoIm"
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "red"
                                  },
                                  attrs: { no: "SopState" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.commonInfo.jobState) + " "
                                  ),
                                  (_vm.job.jobState === 0 ||
                                    _vm.job.jobState === 1 ||
                                    _vm.job.jobState === 2 ||
                                    _vm.job.jobState === 11) &&
                                  _vm.job.shutOut &&
                                  !_vm.commonInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "Message.HasChargeToShutOut"
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  (_vm.job.jobState === 0 ||
                                    _vm.job.jobState === 1 ||
                                    _vm.job.jobState === 2 ||
                                    _vm.job.jobState === 11) &&
                                  _vm.job.shutOut &&
                                  _vm.commonInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "Message.HasChargeToShutOut"
                                                )
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.commonInfo.jobChangeState
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  !(
                                    (_vm.job.jobState === 0 ||
                                      _vm.job.jobState === 1 ||
                                      _vm.job.jobState === 2 ||
                                      _vm.job.jobState === 11) &&
                                    _vm.job.shutOut
                                  ) && _vm.commonInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.commonInfo.jobChangeState
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.job.payableChargeLockedStatus === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            margin: "0px 0px 0px 0px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_PayableLockedStatusTag"
                                              )
                                            )
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  _vm.payableChargeLockedTooltip,
                                                placement: "bottom",
                                                "visible-arrow": false
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      _vm.action === "edit"
                                        ? ""
                                        : _vm.$t("SeaExport.Tip1"),
                                    placement: "bottom-start"
                                  }
                                },
                                [
                                  [
                                    _vm.action === "edit" &&
                                    _vm.activeTabName === "tabCharges"
                                      ? _c("span", {
                                          staticStyle: {
                                            "font-size": "12px",
                                            padding: "7px 9px",
                                            color: "unset"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.commonInfo.chargeJobTitle
                                            )
                                          }
                                        })
                                      : _c("el-button", {
                                          staticStyle: {
                                            "font-size": "12px",
                                            padding: "7px 9px",
                                            color: "unset"
                                          },
                                          attrs: { no: "23", type: "text" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.commonInfo.jobTitle
                                            )
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.onBtnListDoubleClicked()
                                            }
                                          }
                                        })
                                  ]
                                ],
                                2
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "red"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                              ),
                              _vm.commonInfo.provisionLock &&
                              _vm.commonInfo.provisionLock.etdLocked
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "red",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [_vm._v("计提已校准")]
                                  )
                                : _vm._e(),
                              _vm.job.zyCreditWarning
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.job.zyCreditWarning,
                                        placement: "bottom-start",
                                        "visible-arrow": false
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "right-tip",
                                          staticStyle: {
                                            cursor: "pointer",
                                            "font-size": "12px",
                                            color: "orange",
                                            width: "350px",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                            "white-space": "nowrap"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.job.zyCreditWarning)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isNew &&
                                  _vm.activeTabName === "tabCharges",
                                expression:
                                  "isNew&&activeTabName==='tabCharges'"
                              }
                            ],
                            domProps: {
                              innerHTML: _vm._s(_vm.commonInfo.chargeJobTitle)
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      class:
                        "tabs-container" +
                        (_vm.canOperateJob ? "" : " cannot-operate-job")
                    },
                    [
                      _c(
                        "el-tabs",
                        {
                          ref: "tabs",
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "card",
                            "before-leave": function(
                              activeName,
                              oldActiveName
                            ) {
                              _vm.beforeLeaveTab(activeName, oldActiveName)
                            }
                          },
                          on: { "tab-click": _vm.handleTabClick },
                          model: {
                            value: _vm.activeTabName,
                            callback: function($$v) {
                              _vm.activeTabName = $$v
                            },
                            expression: "activeTabName"
                          }
                        },
                        [
                          !_vm.masterFlag
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 1,
                                  attrs: {
                                    lazy: true,
                                    name: "basicTab",
                                    label: _vm.$t("SeaExport.Basic")
                                  }
                                },
                                [
                                  _vm.$store.state.uiCustom.enable && !_vm.isFba
                                    ? _c("tab-general-UICustom", {
                                        ref: "basicTab",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "is-fba": _vm.isFba,
                                          "cooperate-edit":
                                            _vm.cooperateEditOther,
                                          "view-source": "AeBooking",
                                          "template-name": _vm.templateName,
                                          "provision-lock":
                                            _vm.commonInfo.provisionLock
                                        },
                                        on: {
                                          containerLoadTypeEvent:
                                            _vm.containerLoadTypeEvent,
                                          tabNotCheckedCallBack:
                                            _vm.tabNotCheckedCallBack,
                                          generalMChargeWeight:
                                            _vm.generalMChargeWeightHandler,
                                          generalHChargeWeight:
                                            _vm.generalHChargeWeightHandler,
                                          removeJobFromMaster:
                                            _vm.removeJobFromMaster,
                                          detchJobFromMaster:
                                            _vm.detchJobFromMaster,
                                          changeOperateType:
                                            _vm.changeOperateType,
                                          syncDocSft: _vm.syncDocSft,
                                          updateJob: _vm.updateJob
                                        }
                                      })
                                    : _c("basic-tab", {
                                        ref: "basicTab",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "is-fba": _vm.isFba,
                                          "cooperate-edit":
                                            _vm.cooperateEditOther,
                                          "view-source": "AeBooking",
                                          "template-name": _vm.templateName,
                                          "provision-lock":
                                            _vm.commonInfo.provisionLock
                                        },
                                        on: {
                                          containerLoadTypeEvent:
                                            _vm.containerLoadTypeEvent,
                                          tabNotCheckedCallBack:
                                            _vm.tabNotCheckedCallBack,
                                          generalMChargeWeight:
                                            _vm.generalMChargeWeightHandler,
                                          generalHChargeWeight:
                                            _vm.generalHChargeWeightHandler,
                                          removeJobFromMaster:
                                            _vm.removeJobFromMaster,
                                          detchJobFromMaster:
                                            _vm.detchJobFromMaster,
                                          changeOperateType:
                                            _vm.changeOperateType,
                                          syncDocSft: _vm.syncDocSft,
                                          updateJob: _vm.updateJob
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.masterFlag
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 2,
                                  attrs: {
                                    lazy: true,
                                    name: "masterBasicTab",
                                    label: _vm.$t("SeaExport.Basic")
                                  }
                                },
                                [
                                  _vm.$store.state.uiCustom.enable && !_vm.isFba
                                    ? _c("tab-master-UICustom", {
                                        ref: "masterBasicTab",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "is-fba": _vm.isFba,
                                          "is-sea-export": true,
                                          "view-source": "AeBooking",
                                          "cooperate-edit":
                                            _vm.cooperateEditOther,
                                          "template-name": _vm.templateName,
                                          "provision-lock":
                                            _vm.commonInfo.provisionLock
                                        },
                                        on: {
                                          addLcl: _vm.addBatchLcl,
                                          selectJob: function(jobUuid) {
                                            _vm.transferTargetRow(
                                              "edit",
                                              jobUuid
                                            )
                                          },
                                          addSlavedJob: _vm.addSlavedJob,
                                          removeJobFromMaster:
                                            _vm.removeJobFromMaster,
                                          removeJob: _vm.removeJob,
                                          containerLoadTypeEvent:
                                            _vm.containerLoadTypeEvent,
                                          goBack: _vm.goBackForDeleteJob,
                                          generalMChargeWeight:
                                            _vm.generalMChargeWeightHandler
                                        }
                                      })
                                    : _c("master-basic-tab", {
                                        ref: "masterBasicTab",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "is-fba": _vm.isFba,
                                          "is-sea-export": true,
                                          "view-source": "bookingWorkspace",
                                          "cooperate-edit":
                                            _vm.cooperateEditOther,
                                          "template-name": _vm.templateName,
                                          "provision-lock":
                                            _vm.commonInfo.provisionLock
                                        },
                                        on: {
                                          addLcl: _vm.addBatchLcl,
                                          selectJob: function(jobUuid) {
                                            _vm.transferTargetRow(
                                              "edit",
                                              jobUuid
                                            )
                                          },
                                          addSlavedJob: _vm.addSlavedJob,
                                          removeJobFromMaster:
                                            _vm.removeJobFromMaster,
                                          removeJob: _vm.removeJob,
                                          containerLoadTypeEvent:
                                            _vm.containerLoadTypeEvent,
                                          goBack: _vm.goBackForDeleteJob,
                                          generalMChargeWeight:
                                            _vm.generalMChargeWeightHandler
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-tab-pane",
                            {
                              key: "tabAirVesselEq",
                              attrs: {
                                lazy: true,
                                name: "tabAirVesselEq",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-vessel-eq-UICustom", {
                                    ref: "tabAirVesselEq",
                                    attrs: {
                                      context: _vm.context,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      action: _vm.action,
                                      job: _vm.job
                                    }
                                  })
                                : _c("tab-air-vessel-eq", {
                                    ref: "tabAirVesselEq",
                                    attrs: {
                                      context: _vm.context,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      action: _vm.action,
                                      job: _vm.job
                                    }
                                  })
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            {
                              key: "tabAirDataTracking",
                              attrs: {
                                lazy: true,
                                name: "tabAirDataTracking",
                                label: _vm.$t("SeaExport.AirDataTracking")
                              }
                            },
                            [
                              _c("tab-air-data-tracking", {
                                ref: "tabAirDataTracking",
                                attrs: {
                                  context: _vm.context,
                                  job: _vm.job,
                                  action: _vm.action
                                },
                                on: {
                                  "update:job": function($event) {
                                    _vm.job = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: "tabUsCustomsClearance",
                                  attrs: {
                                    lazy: true,
                                    name: "tabUsCustomsClearance",
                                    label: _vm.$t("queryJob.UsCustomsClearance")
                                  }
                                },
                                [
                                  _c("tab-us-customs-clearance", {
                                    ref: "tabUsCustomsClearance",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "show-sync":
                                        _vm.btnInfo
                                          .btnEntrustmentAISynchronized,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: "tabUsCustomsClearanceMaster",
                                  attrs: {
                                    lazy: true,
                                    name: "tabUsCustomsClearanceMaster",
                                    label: _vm.$t("queryJob.UsCustomsClearance")
                                  }
                                },
                                [
                                  _c("tab-us-customs-clearance-master", {
                                    ref: "tabUsCustomsClearanceMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "show-sync":
                                        _vm.btnInfo
                                          .btnEntrustmentAISynchronized,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          (!_vm.isNew || _vm.action === "copy") &&
                          (_vm.masterFlag ||
                            _vm.paramsOfTab.operateType === 2 ||
                            _vm.paramsOfTab.operateType === 3)
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 6,
                                  attrs: {
                                    lazy: true,
                                    name: "tabMAWB",
                                    label: "MAWB"
                                  }
                                },
                                [
                                  _c("tab-mawb", {
                                    ref: "tabMAWB",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      tabNotCheckedCallBack:
                                        _vm.tabNotCheckedCallBack,
                                      resetTab: _vm.resetTab
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          (!_vm.isNew || _vm.action === "copy") &&
                          !_vm.masterFlag &&
                          _vm.paramsOfTab.operateType !== 2
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 7,
                                  attrs: {
                                    lazy: true,
                                    name: "tabHAWB",
                                    label: "HAWB"
                                  }
                                },
                                [
                                  _c("tab-hawb", {
                                    ref: "tabHAWB",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      syncData: _vm.syncData
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew && _vm.paramsOfTab.virtualHBL
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 8,
                                  attrs: {
                                    lazy: true,
                                    name: "tabSubBill",
                                    label: _vm.$t("SeaExport.FormalHbl")
                                  }
                                },
                                [
                                  _c("tab-sub-bill", {
                                    ref: "tabSubBill",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      syncData: _vm.syncData
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew &&
                          !_vm.masterFlag &&
                          (_vm.paramsOfTab.operateType !== 0 ||
                            _vm.paramsOfTab.lclMasterUuid)
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 26,
                                  attrs: {
                                    lazy: true,
                                    name: "tabUnitLoadDevice",
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_MountingInformation"
                                    )
                                  }
                                },
                                [
                                  _c("tab-unit-load-device", {
                                    ref: "tabUnitLoadDevice",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew && _vm.masterFlag
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 26,
                                  attrs: {
                                    lazy: true,
                                    name: "tabLclUnitLoadDevice",
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_MountingInformation"
                                    )
                                  }
                                },
                                [
                                  _c("tab-lcl-unit-load-device", {
                                    ref: "tabLclUnitLoadDevice",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew &&
                          _vm.isFba &&
                          !_vm.masterFlag &&
                          _vm.$checkPermission([
                            "tab_FBAAeBooking_fbaSeaWarehouseTab"
                          ])
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 32,
                                  attrs: {
                                    label: _vm.$t(
                                      "AirExport.DomesticWarehouse"
                                    ),
                                    lazy: true,
                                    name: "fbaWarehousingDetail"
                                  }
                                },
                                [
                                  _c("fba-warehousing-detail", {
                                    ref: "fbaWarehousingDetail",
                                    attrs: {
                                      lob: "FBA",
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      source: "fbaAir"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew &&
                          _vm.isFba &&
                          !_vm.masterFlag &&
                          _vm.$checkPermission([
                            "tab_FBAAeBooking_fbaSeaoverSeaWarehouseTab"
                          ])
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 33,
                                  attrs: {
                                    label: _vm.$t("AirExport.ForeignWarehouse"),
                                    lazy: true,
                                    name: "fbaOutWarehouse"
                                  }
                                },
                                [
                                  _c("fba-out-warehouse", {
                                    ref: "fbaOutWarehouse",
                                    attrs: {
                                      action: _vm.action,
                                      context: _vm.context,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      source: "fbaAir"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isFba
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 19,
                                  attrs: {
                                    lazy: true,
                                    name: "tabTradeDetail",
                                    label: _vm.$t("SeaExport.TradeDetail")
                                  }
                                },
                                [
                                  _c("tab-trade-detail", {
                                    ref: "tabTradeDetail",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew &&
                          _vm.isFba &&
                          !_vm.masterFlag &&
                          _vm.$checkPermission([
                            "tab_FBAAeBooking_fbaAirGoodsDetailTab"
                          ])
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 31,
                                  attrs: {
                                    label: _vm.$t("SeaExport.TradeDetail"),
                                    lazy: true,
                                    name: "fbaGoodsDetail"
                                  }
                                },
                                [
                                  _c("tab-warehousing-detail", {
                                    ref: "fbaGoodsDetail",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      source: "fbaAir",
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { reload: _vm.refresh }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.paramsOfTab.itmService
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 20,
                                  attrs: {
                                    lazy: true,
                                    name: "tabTradeCommission",
                                    label: _vm.$t("SeaExport.TradeCommission")
                                  }
                                },
                                [
                                  _c("tab-trade-commission", {
                                    ref: "tabTradeCommission",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.privilege.charge.chargeView
                            ? [
                                !_vm.chargePageSet.hideTabCharge
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        key: 21,
                                        attrs: {
                                          lazy: true,
                                          name: "tabCharges",
                                          label: _vm.$t("SeaExport.Charge")
                                        }
                                      },
                                      [
                                        _c("tab-charges", {
                                          ref: "tabCharges",
                                          attrs: {
                                            context: _vm.context,
                                            action: _vm.action,
                                            location: _vm.location,
                                            "view-source": "AeBooking",
                                            "enable-ui-custom": true,
                                            "provision-lock":
                                              _vm.commonInfo.provisionLock
                                          },
                                          on: {
                                            printDataCallBack:
                                              _vm.tabChargesPrintDataCallBack
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.chargePageSet.arAloneShow &&
                                _vm.$checkPermission([
                                  "tab_Charge_chargeReceivable"
                                ])
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        key: "chargeArTab",
                                        attrs: {
                                          lazy: true,
                                          name: "tabChargesAr",
                                          label: _vm.$t(
                                            "queryJob.FeeReceivable"
                                          )
                                        }
                                      },
                                      [
                                        _c("tab-charges", {
                                          ref: "tabChargesAr",
                                          attrs: {
                                            context: _vm.context,
                                            action: _vm.action,
                                            location: _vm.location,
                                            "view-source": "AeBooking",
                                            "tab-name": "tabChargesAr",
                                            type: "ar",
                                            "enable-ui-custom": true
                                          },
                                          on: {
                                            printDataCallBack:
                                              _vm.tabChargesPrintDataCallBack
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.chargePageSet.apAloneShow &&
                                _vm.$checkPermission([
                                  "tab_Charge_chargePayable"
                                ])
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        key: "chargeApTab",
                                        attrs: {
                                          lazy: true,
                                          name: "tabChargesAp",
                                          label: _vm.$t("queryJob.CostsPayable")
                                        }
                                      },
                                      [
                                        _c("tab-charges", {
                                          ref: "tabChargesAp",
                                          attrs: {
                                            context: _vm.context,
                                            action: _vm.action,
                                            location: _vm.location,
                                            "view-source": "AeBooking",
                                            "tab-name": "tabChargesAp",
                                            type: "ap",
                                            "enable-ui-custom": true
                                          },
                                          on: {
                                            printDataCallBack:
                                              _vm.tabChargesPrintDataCallBack
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          !_vm.isNew &&
                          _vm.privilege.chargeConfirm.chargeConfirmView
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 22,
                                  attrs: {
                                    lazy: true,
                                    name: "tabInternalBill",
                                    label: _vm.$t("SeaExport.InternalBillInfo")
                                  }
                                },
                                [
                                  _c("tab-internal-bill", {
                                    ref: "tabInternalBill",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      location: _vm.location
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew && _vm.privilege.billTab.billTabView
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 23,
                                  attrs: {
                                    lazy: true,
                                    name: "tabOverseaBill",
                                    label: _vm.$t("SeaExport.OverseaBillInfo")
                                  }
                                },
                                [
                                  _c("tab-oversea-bill", {
                                    ref: "tabOverseaBill",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      location: _vm.location,
                                      "view-source": "AeBooking"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew && _vm.privilege.charge.advanceCharge
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 24,
                                  attrs: {
                                    lazy: true,
                                    name: "tabAdvanceCharge",
                                    label: _vm.$t("SeaExport.AdvanceChargeInfo")
                                  }
                                },
                                [
                                  _c("tab-advance-charge", {
                                    ref: "tabAdvanceCharge",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      location: _vm.location
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 18,
                                  attrs: {
                                    lazy: true,
                                    name: "tabCustomsInfo",
                                    label: _vm.$t(
                                      "SeaExport.CustomsDeclarationOnward"
                                    )
                                  }
                                },
                                [
                                  _c("tab-customs-info", {
                                    ref: "tabCustomsInfo",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditCustoms
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew &&
                          (_vm.$store.state.uiCustom.enable &&
                          !_vm.isFba &&
                          _vm.masterFlag
                            ? _vm.paramsOfTab.insure
                            : true)
                            ? _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    lazy: true,
                                    name: "tabInsure",
                                    label: _vm.$t("SeaExport.InsureInfo")
                                  }
                                },
                                [
                                  _c("tab-insure", {
                                    ref: "tabInsure",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 25,
                                  attrs: {
                                    lazy: true,
                                    name: "tabFile",
                                    label: _vm.$t(
                                      "SeaExport.DocumentCirculation"
                                    )
                                  }
                                },
                                [
                                  _c("tab-file", {
                                    ref: "tabFile",
                                    attrs: {
                                      context: _vm.context,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.masterFlag && !_vm.isNew
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 15,
                                  staticStyle: { flex: "0" },
                                  attrs: {
                                    lazy: true,
                                    name: "tabWarehouseTrucking",
                                    label: _vm.$t("SeaExport.WarehouseLoading")
                                  }
                                },
                                [
                                  _c("warehouse-new-page", {
                                    ref: "tabWarehouseTrucking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditWarehouse
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.masterFlag &&
                          !_vm.isNew &&
                          _vm.paramsOfTab.loadingTerm == "DD"
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 29,
                                  attrs: {
                                    lazy: true,
                                    name: "tabTrucking",
                                    label: _vm.$t("SeaExport.Trucking")
                                  }
                                },
                                [
                                  _c("trucking-page", {
                                    ref: "tabTrucking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditTrucking
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.paramsOfTab.dischargingPortDoor &&
                          _vm.privilege.aeBooking.aeDischargingTrukingPage
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: "tabDischargingTrucking",
                                  attrs: {
                                    lazy: true,
                                    name: "tabDischargingTrucking",
                                    label: _vm.$t(
                                      "SeaExport.DispatchVehiclesAtDestination"
                                    )
                                  }
                                },
                                [
                                  _c("tab-discharging-trucking", {
                                    ref: "tabDischargingTrucking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "show-sync":
                                        _vm.btnInfo
                                          .btnEntrustmentAISynchronized,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.masterFlag && !_vm.isNew
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 17,
                                  attrs: {
                                    lazy: true,
                                    name: "tabWarehouse",
                                    label: _vm.$t("SeaExport.CargoInfo")
                                  }
                                },
                                [
                                  _c("tab-warehouse", {
                                    ref: "tabWarehouse",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { refreshTabs: _vm.refresh }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew && _vm.privilege.aeBooking.portalState
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 27,
                                  attrs: {
                                    lazy: true,
                                    name: "tabSopState",
                                    label: _vm.$t("SeaExport.BusinessStatus")
                                  }
                                },
                                [
                                  _c("tab-sop-state", {
                                    ref: "tabSopState",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "controlled-locked": _vm.controlledLocked,
                                      "sop-template-config":
                                        _vm.sopTemplateConfig
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isNew
                            ? _c(
                                "el-tab-pane",
                                {
                                  key: 28,
                                  attrs: {
                                    lazy: true,
                                    name: "tabFileHistory",
                                    label: _vm.$t("SeaExport.FileHistory")
                                  }
                                },
                                [
                                  _c("tab-file-history", {
                                    ref: "tabFileHistory",
                                    attrs: {
                                      context: _vm.context,
                                      "btn-info": _vm.btnInfo,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "can-operate-job": _vm.canOperateJob,
                                      "controlled-locked": _vm.controlledLocked
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            2
          ),
          _vm.job.jobState === _vm.SystemConstants.OPERATING &&
          _vm.activeTabName !== "tabTradeDetail"
            ? _c("drop-uploader", {
                attrs: {
                  action: _vm.URL.common.uploadStorage,
                  "upload-params": _vm.uploadParams
                },
                on: { "upload-end": _vm.globalUploadEnd }
              })
            : _vm._e(),
          _c("cargo-template-selector-dialog", {
            ref: "templateSelectorDialog",
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context,
              "pre-print-callback": _vm.prePrintCallback,
              "printed-callback": _vm.printedCallback,
              "v2-check-callback": _vm.v2CheckCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          }),
          _vm.batchCheckingWindow.visible
            ? _c("batch-checking-window", {
                attrs: {
                  visible: _vm.batchCheckingWindow.visible,
                  lob: _vm.lob,
                  jobs: _vm.batchCheckingWindow.jobs,
                  "check-node": _vm.batchCheckingWindow.checkNode,
                  "call-back": _vm.batchCheckingWindow.callBack,
                  "call-back2": _vm.batchCheckingWindow.callBack2
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.checkingWindow.visible
            ? _c("checking-window", {
                attrs: {
                  visible: _vm.checkingWindow.visible,
                  lob: _vm.lob,
                  job: _vm.job,
                  "check-node": _vm.checkingWindow.checkNode,
                  "call-back": _vm.checkingWindow.callBack,
                  "call-back2": _vm.checkingWindow.callBack2
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.checkingWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _c("estimate-validation-dialog", {
            ref: "estimateValidationDialog",
            attrs: {
              visible: _vm.estimateValidationDialog.visible,
              job: _vm.estimateValidationDialog.job,
              "estimate-profit-rate":
                _vm.estimateValidationDialog.estimateProfitRate,
              "tatol-profit": _vm.estimateValidationDialog.tatolProfit
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
              },
              callback: _vm.estimateValidationDialog.callback
            }
          }),
          _vm.dataPushDialog.visible
            ? _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  staticClass: "app-main-inner",
                  attrs: {
                    no: "24",
                    visible: _vm.dataPushDialog.visible,
                    title: _vm.$t("SeaExport.DataPushChangeLog"),
                    width: "580px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.dataPushDialog, "visible", $event)
                    },
                    close: function($event) {
                      _vm.dataPushDialog.visible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: {
                        padding: "0",
                        display: "flex",
                        "flex-direction": "column"
                      },
                      style: {
                        width: "100%",
                        height: "400px",
                        overflow: "auto"
                      }
                    },
                    _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "div",
                            { staticStyle: { background: "#EBECF5" } },
                            [_c("b", [_vm._v(_vm._s(title))])]
                          ),
                          _vm._l(
                            _vm.dataPushDialog.dataMap.get(title),
                            function(item, index) {
                              return _c("div", { key: index }, [
                                _c("div", [_vm._v(_vm._s(item))])
                              ])
                            }
                          )
                        ],
                        2
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e(),
          _vm.businessStatusDialog.visible
            ? _c("business-status-log-dialog", {
                attrs: {
                  visible: _vm.businessStatusDialog.visible,
                  "job-uuid": _vm.job.uuid || ""
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.businessStatusDialog, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.ediStatusLogDialog.visible
            ? _c("edi-status-log-dialog", {
                attrs: {
                  visible: _vm.ediStatusLogDialog.visible,
                  "job-uuid": _vm.job.uuid || ""
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.ediStatusLogDialog, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.bookingSpaceLogDialog.visible
            ? _c("booking-space-log-dialog", {
                attrs: {
                  visible: _vm.bookingSpaceLogDialog.visible,
                  "job-uuid": _vm.job.uuid || ""
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.bookingSpaceLogDialog,
                      "visible",
                      $event
                    )
                  }
                }
              })
            : _vm._e(),
          _c("sop-state-dialog", {
            attrs: {
              "hide-window": _vm.isEditing,
              visible: _vm.sopStateDialog.visible,
              "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
              "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
              job: _vm.job,
              "is-need-expand": _vm.sopStateDialog.isNeedExpand
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sopStateDialog, "visible", $event)
              },
              "update:isNeedExpand": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
              },
              "update:is-need-expand": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
              },
              handleClose: _vm.sopStateDialogClose
            }
          }),
          _vm.sendBranchWindow.visible
            ? [
                _vm.sendBranchSelectObject === 2
                  ? _c(
                      "el-dialog",
                      {
                        directives: [
                          {
                            name: "el-drag-dialog",
                            rawName: "v-el-drag-dialog"
                          }
                        ],
                        attrs: {
                          no: "25",
                          visible: _vm.sendBranchWindow.visible,
                          title: _vm.$t("SeaExport.ConsignationSI"),
                          width: "550px",
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(
                              _vm.sendBranchWindow,
                              "visible",
                              $event
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "40px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#000000",
                                      "font-size": "14px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.EntrustedRecipient")
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.enableEntrustmentAI,
                                    expression: "!enableEntrustmentAI"
                                  }
                                ],
                                attrs: { label: _vm.$t("queryJob.route") }
                              },
                              [
                                _c("cargo-user-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    no: "26",
                                    "method-params": {
                                      officeId:
                                        _vm.sendBranchWindow.office.officeId,
                                      category: "role",
                                      shape: "airline"
                                    }
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.sendBranchWindow.items[0].userId =
                                        p.value
                                      _vm.userId_changeHandler(
                                        _vm.sendBranchWindow.items[0]
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.enableEntrustmentAI
                              ? _vm._l(_vm.sendBranchWindow.items, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "el-form-item",
                                    {
                                      key: index,
                                      attrs: {
                                        label:
                                          item.selectObject === 0
                                            ? _vm.$t(
                                                "SeaExport.CustomerService"
                                              )
                                            : _vm.$t("SeaExport.Operation")
                                      }
                                    },
                                    [
                                      _c("cargo-user-select", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          no:
                                            "27" +
                                            (index > 0 ? "-" + index : ""),
                                          "method-params": {
                                            officeId:
                                              _vm.sendBranchWindow.office
                                                .officeId,
                                            category: "role",
                                            shape:
                                              item.selectObject === 0
                                                ? "csr"
                                                : "op"
                                          }
                                        },
                                        on: {
                                          change: function(p) {
                                            item.userId = p.value
                                            _vm.userIdAI_changeHandler(item)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "40px",
                              inline: true,
                              "label-position": "left"
                            }
                          },
                          [
                            _c("el-form-item", { attrs: { label: " " } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    color: "#000000",
                                    "font-size": "14px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.getters.currentOffice
                                        .chineseName
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c("el-form-item", { attrs: { label: " " } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    color: "#000000",
                                    "font-size": "14px",
                                    "text-align": "center"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.sendBranchWindow.title))]
                              )
                            ]),
                            _c(
                              "el-form-item",
                              { attrs: { label: " " } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { value: "consignee", disabled: "" }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.Consignee"),
                                        value: "consignee"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "44px" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "rgb(153, 153, 153)"
                                    },
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v("———")]
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    on: { change: _vm.onConsigneeTargetChange },
                                    model: {
                                      value:
                                        _vm.sendBranchWindow.consigneeTarget,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.sendBranchWindow,
                                          "consigneeTarget",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "sendBranchWindow.consigneeTarget"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.Consignee"),
                                        value: "consignee"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.ConsignationCompany"
                                        ),
                                        value: "customer"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: " " } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      value: "consigneeDetail",
                                      disabled: ""
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.ConsigneeDetail"
                                        ),
                                        value: "consigneeDetail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "44px" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "rgb(153, 153, 153)"
                                    },
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v("———")]
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    on: {
                                      change: _vm.onConsigneeDetailTargetChange
                                    },
                                    model: {
                                      value:
                                        _vm.sendBranchWindow
                                          .consigneeDetailTarget,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.sendBranchWindow,
                                          "consigneeDetailTarget",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "sendBranchWindow.consigneeDetailTarget"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.ConsigneeDetail"
                                        ),
                                        value: "consigneeDetail"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.ShipperDetail"
                                        ),
                                        value: "shipperDetail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticStyle: { "margin-top": "20px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "queryJob.NoteConsigneeCustomerExportImport"
                              )
                            )
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            },
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { color: "#000000" },
                                on: {
                                  change: _vm.onCheckConsigneeDefaultChange
                                },
                                model: {
                                  value:
                                    _vm.sendBranchWindow.checkConsigneeDefault,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "checkConsigneeDefault",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "sendBranchWindow.checkConsigneeDefault"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("queryJob.SetAsDefaultExportInfo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "28", type: "primary" },
                                    on: { click: _vm.enterSendHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "29" },
                                    on: {
                                      click: function($event) {
                                        _vm.sendBranchWindow.visible = false
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "el-dialog",
                      {
                        directives: [
                          {
                            name: "el-drag-dialog",
                            rawName: "v-el-drag-dialog"
                          }
                        ],
                        attrs: {
                          no: "25",
                          visible: _vm.sendBranchWindow.visible,
                          title: _vm.sendBranchWindow.title,
                          width: "360px",
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(
                              _vm.sendBranchWindow,
                              "visible",
                              $event
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "85px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.enableEntrustmentAI,
                                    expression: "!enableEntrustmentAI"
                                  }
                                ],
                                attrs: { label: _vm.$t("queryJob.route") }
                              },
                              [
                                _c("cargo-user-select", {
                                  attrs: {
                                    no: "26",
                                    "method-params": {
                                      officeId:
                                        _vm.sendBranchWindow.office.officeId,
                                      category: "role",
                                      shape: "airline"
                                    }
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.sendBranchWindow.items[0].userId =
                                        p.value
                                      _vm.userId_changeHandler(
                                        _vm.sendBranchWindow.items[0]
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.enableEntrustmentAI
                              ? _vm._l(_vm.sendBranchWindow.items, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "el-form-item",
                                    {
                                      key: index,
                                      attrs: {
                                        label:
                                          item.selectObject === 0
                                            ? _vm.$t(
                                                "SeaExport.CustomerService"
                                              )
                                            : _vm.$t("SeaExport.Operation")
                                      }
                                    },
                                    [
                                      _c("cargo-user-select", {
                                        attrs: {
                                          no:
                                            "27" +
                                            (index > 0 ? "-" + index : ""),
                                          "method-params": {
                                            officeId:
                                              _vm.sendBranchWindow.office
                                                .officeId,
                                            category: "role",
                                            shape:
                                              item.selectObject === 0
                                                ? "csr"
                                                : "op"
                                          }
                                        },
                                        on: {
                                          change: function(p) {
                                            item.userId = p.value
                                            _vm.userIdAI_changeHandler(item)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                })
                              : _vm._e(),
                            _vm.showdCheckSalesMapping
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("queryJob.SalesMapping")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { no: "checkSalesMapping" },
                                        model: {
                                          value:
                                            _vm.sendBranchWindow
                                              .checkSalesMapping,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.sendBranchWindow,
                                              "checkSalesMapping",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "sendBranchWindow.checkSalesMapping"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "queryJob.SalesCargoSalesMap"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              margin: "0 auto",
                              width: "fit-content"
                            },
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "28", type: "primary" },
                                on: { click: _vm.enterSendHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "29" },
                                on: {
                                  click: function($event) {
                                    _vm.sendBranchWindow.visible = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
              ]
            : _vm._e(),
          _vm.trustFromWindow.visible
            ? _c("ae-trust-from-window", {
                ref: "trustFromWindow",
                attrs: {
                  visible: _vm.trustFromWindow.visible,
                  "trust-job": _vm.trustFromWindow.trustJob,
                  job: _vm.trustFromWindow.job,
                  context: _vm.context,
                  "can-operate-job": _vm.canOperateJob
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.trustFromWindow, "visible", $event)
                  },
                  refresh: _vm.applyCloseAndRefresh
                }
              })
            : _vm._e(),
          _vm.shutOutDialog.visible
            ? _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  attrs: {
                    no: "30",
                    visible: _vm.shutOutDialog.visible,
                    title: _vm.$t("Message.Warning"),
                    width: "400px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.shutOutDialog, "visible", $event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "padding-left": "30px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { "line-height": "40px" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.PleaseConfirmTheShutOut"))
                        )
                      ]),
                      _c("span", { staticStyle: { "line-height": "18px" } }, [
                        _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                      ]),
                      _c("span", { staticStyle: { "line-height": "18px" } }, [
                        _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { margin: "0 auto", width: "fit-content" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "31", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.hasChargeShutoutHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                      ),
                      _c(
                        "el-button",
                        {
                          style: {
                            display: _vm.shutOutDialog.shutOutButtonShow2
                          },
                          attrs: { no: "32", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.noHasChargeShutoutHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "33" },
                          on: {
                            click: function($event) {
                              _vm.shutOutDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.checkingSaveJobWindow.visible
            ? _c("checking-save-job-window", {
                attrs: {
                  visible: _vm.checkingSaveJobWindow.visible,
                  lob: "AE",
                  "row-data": _vm.checkingSaveJobWindow.rowData,
                  "check-node": _vm.checkingSaveJobWindow.checkNode,
                  "call-back": _vm.checkingSaveJobWindow.callBack
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.checkingSaveJobWindow,
                      "visible",
                      $event
                    )
                  }
                }
              })
            : _vm._e(),
          _vm.relatedAiFromWindow.visible
            ? _c("related-ai-from-window", {
                attrs: {
                  visible: _vm.relatedAiFromWindow.visible,
                  "related-job": _vm.relatedAiFromWindow.relatedJob,
                  "can-operate-job": _vm.canOperateJob
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.relatedAiFromWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.cooperationBranchListDialog.visible
            ? _c("cooperation-branch-list", {
                attrs: {
                  visible: _vm.cooperationBranchListDialog.visible,
                  "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
                  job: _vm.cooperationBranchListDialog.job,
                  "order-center-branch":
                    _vm.cooperationBranchListDialog.orderCenterBranch
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.cooperationBranchListDialog,
                      "visible",
                      $event
                    )
                  },
                  refresh: function(cooperatebranch) {
                    _vm.updateJobCooperate(cooperatebranch)
                    this$1.$refs.tabCharges.refreshCooperatebranch(
                      cooperatebranch
                    )
                  },
                  cancel: function() {
                    return (_vm.cooperationBranchListDialog.visible = false)
                  }
                }
              })
            : _vm._e(),
          _vm.jobApplyDialog.visible
            ? _c("job-apply-dialog", {
                attrs: {
                  visible: _vm.jobApplyDialog.visible,
                  title: _vm.$t("CargoMsg.Cargo_SubmitJobChargeForApproval"),
                  type: "apply",
                  "doc-id": _vm.job.uuid,
                  "document-config-id": _vm.documentConfigId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.jobApplyDialog, "visible", $event)
                  },
                  close: function($event) {
                    _vm.jobApplyDialog.visible = false
                  },
                  closeAndRefresh: _vm.applyCloseAndRefresh
                }
              })
            : _vm._e(),
          _c("data-update-log-dialog", {
            attrs: {
              "hide-window": _vm.isEditing,
              visible: _vm.dataUpdateLogDialog.visible,
              "is-need-refresh": _vm.dataUpdateLogDialog.isNeedRefresh,
              "default-is-expand": _vm.dataUpdateLogDialog.defaultIsExpand,
              job: _vm.job,
              "is-need-expand": _vm.dataUpdateLogDialog.isNeedExpand
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dataUpdateLogDialog, "visible", $event)
              },
              "update:isNeedExpand": function($event) {
                return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
              },
              "update:is-need-expand": function($event) {
                return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
              },
              handleClose: _vm.dataUpdateLogDialogClose
            }
          }),
          _c("import-order-dialog", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.importOrderDialog.visible,
                expression: "importOrderDialog.visible"
              }
            ],
            ref: "importOrderDialog",
            attrs: {
              visible: _vm.importOrderDialog.visible,
              lob: _vm.importOrderDialog.job.lob || "AE",
              job: _vm.importOrderDialog.job
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.importOrderDialog, "visible", $event)
              },
              confirmCallBack: function(data) {
                _vm.importOrderConfirmCallBack(data)
              }
            }
          }),
          _c("job-return-review-dialog", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.returnReviewDialog.visible,
                expression: "returnReviewDialog.visible"
              }
            ],
            attrs: {
              visible: _vm.returnReviewDialog.visible,
              lob: "AE",
              "selected-jobs": _vm.returnReviewDialog.selectedJobs,
              srouce: "detail"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.returnReviewDialog, "visible", $event)
              },
              confirm: _vm.refresh
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }